import Vue from 'vue';

Vue.filter('markdown', function (content, mode) {
    var markdownHighlight = require('highlight.js');
    var markdownFontAwesome = require('./ForkedModules/markdown-it-fontawesome');
    var markdownTargetBlank = require('./ForkedModules/markdown-it-target-blank');
    var disabled;

    if (mode && mode === 'limited') {
        disabled = ['heading']
    }

    var md = require('markdown-it')({
        html: false,
        linkify: true,
        breaks: true,
        typographer: true,
        highlight: function (str, lang) {
            if (lang && markdownHighlight.getLanguage(lang)) {
                try {
                    return markdownHighlight.highlight(lang, str).value;
                } catch (__) {
                    return '';
                }
            }

            return '';
        }
    })
        .use(markdownFontAwesome)
        .use(markdownTargetBlank);

    if (disabled) {
        md.disable(disabled)
    }

    content = md.render(content);

    return (content);
});